// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Specs_TheComp__jTv0w"};